import styled from '@emotion/styled'

export const NotificationsWrapper = styled.div`
  width: 100%;
`
